import React from 'react';
import { Alert, LiveRegion } from '@global-ecom/nitro-uds/elements';

import { useSiteConfig } from 'hooks/useSiteConfig';
import { DateFormatterOptions, useDateFormatter } from 'hooks/useDateFormatter';

type ScheduledArrivalDateProps = {
  preOrderDeliveryDate: string;
};

const ScheduledArrivalDate: React.FC<ScheduledArrivalDateProps> = ({
  preOrderDeliveryDate,
}) => {
  const { scheduledArrivalDateFormat } = useSiteConfig();

  const dateFormatOptions: DateFormatterOptions = {
    date: preOrderDeliveryDate,
    format: scheduledArrivalDateFormat,
    text: 'scheduledArrivalDate',
  };

  const formattedDate = useDateFormatter(dateFormatOptions);

  return (
    <LiveRegion type="polite">
      <Alert content={formattedDate} variant="info" />
    </LiveRegion>
  );
};

export default ScheduledArrivalDate;
